import * as React from "react";

function IconBrandFigma({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-figma" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/brand-figma"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><circle cx={15} cy={12} r={3} /><rect x={6} y={3} width={12} height={6} rx={3} /><path d="M9 9a3 3 0 0 0 0 6h3m-3 0a3 3 0 1 0 3 3v-15" /></svg>;
}

export default IconBrandFigma;